import { c as _c } from "react/compiler-runtime";
import { Heading } from 'design-system/client';
import Image from 'next/image';
import styles from './HeroImage.module.css';
import { HeroImageProps } from './types';
import TextLink from '@/components/TextLink';
import classNames from 'classnames';
function HeroImage(t0) {
  const $ = _c(16);
  let props;
  let receiverName;
  let receiverProfilePicture;
  if ($[0] !== t0) {
    ({
      receiverName,
      receiverProfilePicture,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = receiverName;
    $[3] = receiverProfilePicture;
  } else {
    props = $[1];
    receiverName = $[2];
    receiverProfilePicture = $[3];
  }
  let t1;
  if ($[4] !== receiverName) {
    t1 = <Heading level="heading-sm">{receiverName}</Heading>;
    $[4] = receiverName;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const heading = t1;
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames(styles.container, styles.imageContainer);
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== receiverProfilePicture) {
    t3 = <div className={t2}><Image src={receiverProfilePicture} alt="" width={640} height={333} className={styles.image} priority={true} loading="eager" /></div>;
    $[7] = receiverProfilePicture;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== heading || $[10] !== props.linked || $[11] !== props.receiverUrl) {
    t4 = <div className={styles.headingContainer}>{props.linked ? <TextLink href={props.receiverUrl} className={styles.heading}>{heading}</TextLink> : heading}</div>;
    $[9] = heading;
    $[10] = props.linked;
    $[11] = props.receiverUrl;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
export default HeroImage;